<script>import Blocks from "../../components/blocks/blocks.svelte";
export let defaultActiveTab = undefined;
export let tabs;
export let collapsible = undefined;
export let tabHeaderLayout = undefined;
export let activeTabStyle = undefined;
export let builderBlock;
export let builderContext;
export let builderComponents;
export let builderLinkComponent = undefined;
function stringifyStyles(stylesObj) {
    let styles = "";
    for (let key in stylesObj) {
        const dashedKey = key.replace(/[A-Z]/g, function (match) {
            return "-" + match.toLowerCase();
        });
        styles += dashedKey + ":" + stylesObj[key] + ";";
    }
    return styles;
}
function activeTabContent(active) {
    return tabs && tabs[active].content;
}
function onClick(index) {
    if (index === activeTab && collapsible) {
        activeTab = -1;
    }
    else {
        activeTab = index;
    }
}
let activeTab = defaultActiveTab ? defaultActiveTab - 1 : 0;
</script>

<div>
  <div
    style={stringifyStyles({
      display: "flex",
      flexDirection: "row",
      justifyContent: tabHeaderLayout || "flex-start",
      overflow: "auto",
    })}
    class="builder-tabs-wrap"
  >
    {#each tabs as tab, index (index)}
      <span
        style={stringifyStyles({
          ...(activeTab === index ? activeTabStyle : {}),
        })}
        class={`builder-tab-wrap ${
          activeTab === index ? "builder-tab-active" : ""
        }`}
        on:click={(event) => {
          onClick(index);
        }}
        ><Blocks
          parent={builderBlock.id}
          path={`component.options.tabs.${index}.label`}
          blocks={tab.label}
          context={builderContext}
          registeredComponents={builderComponents}
          linkComponent={builderLinkComponent}
        /></span
      >
    {/each}
  </div>
  {#if activeTabContent(activeTab)}
    <div>
      <Blocks
        parent={builderBlock.id}
        path={`component.options.tabs.${activeTab}.content`}
        blocks={activeTabContent(activeTab)}
        context={builderContext}
        registeredComponents={builderComponents}
        linkComponent={builderLinkComponent}
      />
    </div>
  {/if}
</div>